import Select from "react-select";
import moment from "moment";
import DatePicker from "react-datepicker";
import { Label } from "reactstrap";
import { CalenderIcon } from "../../Icon";
import {
  BankIdDetailsType,
  UserProfileType,
} from "../../../redux/auth/authTypes";
import BankAccoundDetails from "./BankAccoundDetails";
import {
  handleDate,
  isPanValid,
  returnInputFieldLength,
} from "../../../utils/commonFunctions";
import { Loader, RollingLoader } from "../../commons";
import { useLocation } from "react-router-dom";
import { useState } from "react";
import {
  DisableiIcon,
  EnableiIcon,
  RedCheckIcon,
  VerifyIcon,
  WhiteCheckIcon,
} from "../../../assets/images";
import {
  BankAccountInfoType,
  PanVerifyType,
} from "../../../redux/services/serviceTypes";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

type AppProps = {
  data: BankIdDetailsType;
  handleBankWorkForm: (data: any) => void;
  handleBankAccountWorkForm: (data: any) => void;
  setProfileForm: any;
  aadhaarFetching: boolean;
  aadhaarMessage: string | null;
  isAadhaarNo: null | number;
  panFetching: boolean;
  panMessage: string | null;
  isPanNo: null | number;
  passportFetching: boolean;
  passportMessage: string | null;
  isPassportNo: number | null;
  uanFetching: boolean;
  servicesFetching?: boolean;
  uanMessage: string | null;
  isUanNo: number | null;
  getPanDetails?: (data: any) => void;
  getBankDetails?: (data: any) => void;
  resetBankDetailsData?: () => void;
  bankAccountDetails?: BankAccountInfoType | null;
  userProfileAllData?: UserProfileType;
  isEdit?: boolean;
  panVerifyDetails?: PanVerifyType | null;
  servicesError?: string | null;
};

const BankIdDetails = ({
  data,
  setProfileForm,
  handleBankWorkForm,
  handleBankAccountWorkForm,
  aadhaarFetching,
  aadhaarMessage,
  isAadhaarNo,
  panFetching,
  panMessage,
  isPanNo,
  passportFetching,
  passportMessage,
  isPassportNo,
  uanFetching,
  uanMessage,
  isUanNo,
  getPanDetails,
  getBankDetails,
  bankAccountDetails,
  resetBankDetailsData,
  servicesFetching,
  userProfileAllData,
  isEdit,
  panVerifyDetails,
  servicesError,
}: AppProps) => {
  const { pathname } = useLocation();
  let show = pathname.includes("external-user");
  const [isHovered, setIsHovered] = useState(false);

  const handleHourlyChargeChange = (data: any) => {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        payroll_settings: {
          ...prv.payroll_settings,
          hourly_charge: data?.target?.value,
        },
      };
    });
  };
  const handleStandardHourChange = (data: any) => {
    setProfileForm((prv: UserProfileType) => {
      return {
        ...prv,
        payroll_settings: {
          ...prv.payroll_settings,
          standard_hour: data?.target?.value,
        },
      };
    });
  };

  return (
    <>
      <div className="form-group" style={{ marginTop: "15px" }}>
        <p style={{ fontSize: "20px", fontWeight: 500, marginBottom: "6px" }}>
          Payroll Settings
        </p>

        <div className="row mb-4">
          {!show && (
            <div className="col-md-3">
              <label htmlFor="hourly_charge">Hourly charge out rate</label>
              <input
                type="text"
                className="form-control"
                name="hourly_charge"
                value={data?.hourly_charge}
                onChange={handleHourlyChargeChange}
                onWheel={(event) => event.currentTarget.blur()}
              />
            </div>
          )}
          {!show && (
            <div className="col-md-3">
              <label htmlFor="standard_hour">Standard hours</label>
              <input
                type="number"
                className="form-control"
                name="standard_hour"
                value={data?.standard_hour || ""}
                onChange={handleStandardHourChange}
                onWheel={(event) => event.currentTarget.blur()}
              />
            </div>
          )}
        </div>
        <p style={{ fontSize: "15px", fontWeight: 500, marginBottom: "6px" }}>
          IDENTIFICATION DETAILS
        </p>
        <div className="row">
          <div className="col-md-3">
            <label htmlFor="pan">PAN</label>
            <div className="d-flex flex-row position-relative">
              <input
                type="text"
                // className={`form-control`}
                className={`form-control ${
                  panMessage?.includes("PAN number already exists")
                    ? "error-border"
                    : null
                }`}
                name="pan"
                onChange={handleBankWorkForm}
                maxLength={10}
                value={data?.identification_details?.pan}
              />
              <span
                className="position-absolute"
                style={{ top: "7px", right: "5px" }}
              >
                {(!isEdit &&
                  panVerifyDetails?.status === "VALID" &&
                  data?.identification_details?.pan?.length === 10) ||
                panVerifyDetails?.status === "VALID" ||
                (isEdit &&
                  userProfileAllData?.payroll_settings?.identification_details
                    ?.pan_details &&
                  userProfileAllData?.payroll_settings?.identification_details
                    ?.pan_details?.status === "VALID" &&
                  userProfileAllData?.payroll_settings?.identification_details
                    ?.pan_details?.pan === data?.identification_details?.pan &&
                  data?.identification_details?.pan?.length === 10) ? (
                  <OverlayTrigger
                    placement="top"
                    delay={{ show: 250, hide: 250 }}
                    overlay={
                      <Tooltip id="button-view-filter-invoice">
                        <div>
                          <div className="text-left">
                            Full Name :{" "}
                            {data?.identification_details?.pan_details
                              ?.full_name
                              ? data?.identification_details?.pan_details
                                  ?.full_name
                              : userProfileAllData?.payroll_settings
                                  ?.identification_details?.pan_details
                                  ?.full_name
                              ? userProfileAllData?.payroll_settings
                                  ?.identification_details?.pan_details
                                  ?.full_name
                              : "NA"}
                          </div>
                          <div className="text-left">
                            PAN No :{" "}
                            {data?.identification_details?.pan_details?.pan
                              ? data?.identification_details?.pan_details?.pan
                              : userProfileAllData?.payroll_settings
                                  ?.identification_details?.pan_details?.pan
                              ? userProfileAllData?.payroll_settings
                                  ?.identification_details?.pan_details?.pan
                              : "NA"}
                          </div>
                          <div className="text-left">
                            Category :{" "}
                            {data?.identification_details?.pan_details?.category
                              ? data?.identification_details?.pan_details
                                  ?.category
                              : userProfileAllData?.payroll_settings
                                  ?.identification_details?.pan_details
                                  ?.category
                              ? userProfileAllData?.payroll_settings
                                  ?.identification_details?.pan_details
                                  ?.category
                              : "NA"}
                          </div>
                          <div className="text-left">
                            Status :{" "}
                            {data?.identification_details?.pan_details?.status
                              ? data?.identification_details?.pan_details
                                  ?.status
                              : userProfileAllData?.payroll_settings
                                  ?.identification_details?.pan_details?.status
                              ? userProfileAllData?.payroll_settings
                                  ?.identification_details?.pan_details?.status
                              : "NA"}
                          </div>
                        </div>
                      </Tooltip>
                    }
                  >
                    <img src={EnableiIcon} />
                  </OverlayTrigger>
                ) : (
                  <img src={DisableiIcon} />
                )}
              </span>
              {panFetching && data?.identification_details?.pan && (
                <RollingLoader />
              )}
            </div>
            {data?.identification_details?.pan &&
            isPanNo === 1 &&
            panMessage?.includes("PAN number already exists") ? (
              <small className="text-danger">
                Pan number is already in use!
              </small>
            ) : (
              ""
            )}
            <div style={{ margin: "0px" }}>
              {(!isEdit &&
                panVerifyDetails?.status === "VALID" &&
                data?.identification_details?.pan?.length === 10) ||
              panVerifyDetails?.status === "VALID" ||
              (isEdit &&
                userProfileAllData?.payroll_settings?.identification_details
                  ?.pan_details &&
                userProfileAllData?.payroll_settings?.identification_details
                  ?.pan_details?.status === "VALID" &&
                userProfileAllData?.payroll_settings?.identification_details
                  ?.pan_details?.pan === data?.identification_details?.pan &&
                data?.identification_details?.pan?.length === 10) ? (
                <span>
                  <img src={VerifyIcon} alt="pan" />{" "}
                  <span style={{ color: "#28a745" }}>PAN is Verified</span>
                </span>
              ) : panVerifyDetails?.status === "INVALID" ? (
                <span className="text-danger">PAN is Invalid</span>
              ) : (
                <span className="input-length">
                  {returnInputFieldLength(
                    data?.identification_details?.pan?.length,
                    10
                  )}
                </span>
              )}
            </div>
          </div>
          <div className="col-md-2 mt-4">
            <div className="form-group">
              <button
                className="btn btn-outline"
                disabled={
                  (!!data?.identification_details?.pan &&
                  data?.identification_details?.pan?.length > 9
                    ? false
                    : true) ||
                  (!!data?.identification_details?.pan?.length &&
                    !isPanValid(
                      data?.identification_details?.pan?.length
                        ? data?.identification_details?.pan?.trim()
                        : ""
                    ))
                }
                onClick={(e) => getPanDetails?.(e)}
                onMouseEnter={() => setIsHovered(true)}
                onMouseLeave={() => setIsHovered(false)}
              >
                <img
                  src={isHovered ? WhiteCheckIcon : RedCheckIcon}
                  alt="check"
                />{" "}
                <span>Verify</span>
              </button>
            </div>
          </div>
        </div>
        <div className="row mt-2">
          <div className="col-md-3">
            <label htmlFor="passportNo">Passport No.</label>
            <div className="d-flex flex-row position-relative">
              <input
                type="text"
                className={`form-control ${
                  passportMessage?.includes("Passport number already exists")
                    ? "error-border"
                    : null
                }`}
                name="passport_number"
                value={data?.identification_details?.passport_number}
                onChange={handleBankWorkForm}
              />
              {passportFetching &&
                data?.identification_details?.passport_number && (
                  <RollingLoader />
                )}
            </div>
            {data?.identification_details?.passport_number &&
            isPassportNo === 1 &&
            passportMessage?.includes("Passport number already exists") ? (
              <small className="text-danger">
                Passport number is already in use!
              </small>
            ) : (
              ""
            )}
          </div>

          <div className="col-md-3">
            <label htmlFor="passportExpiry">Passport Expiry</label>
            <div className="d-flex flex-row position-relative">
              <div className="date-picker-wraper mr-0 w-100">
                <Label className="mr-0 w-100">
                  <DatePicker
                    dateFormat="dd-MM-yyyy"
                    selected={
                      data?.identification_details?.passport_expiry
                        ? new Date(
                            moment(
                              `${data?.identification_details?.passport_expiry}T00:00:00`,
                              "YYYY-MM-DD"
                            ).format("YYYY-MM-DD[T]HH:mm:ss")
                          )
                        : null
                    }
                    onChange={(e: any) => {
                      // handleDateChange?.(moment(e).format("YYYY-MM-DD"));
                      let passporteExpiry = handleDate(
                        moment(e).format("YYYY-MM-DD")
                      );
                      setProfileForm((prv: UserProfileType) => {
                        return {
                          ...prv,
                          payroll_settings: {
                            ...prv?.payroll_settings,
                            identification_details: {
                              ...prv?.payroll_settings?.identification_details,
                              passport_expiry: passporteExpiry,
                            },
                          },
                        };
                      });
                    }}
                    fixedHeight
                    showMonthDropdown
                    showYearDropdown
                    // disabled={!isEdit}
                    name="date_of_birth"
                    placeholderText="Select"
                    className="form-control"
                  />
                  <span
                    className="calender-icon"
                    style={{ right: "20px", top: "10px", cursor: "pointer" }}
                  >
                    <CalenderIcon />
                  </span>
                </Label>
              </div>
            </div>
          </div>
          <div className="col-md-3">
            <label htmlFor="aadharNo">Aadhar No.</label>
            <div className="d-flex flex-row position-relative">
              <input
                type="number"
                // className={`form-control`}
                className={`form-control ${
                  aadhaarMessage?.includes("Aadhaar number already exists")
                    ? "error-border"
                    : null
                }`}
                name="adhar_number"
                onChange={handleBankWorkForm}
                value={data?.identification_details?.adhar_number}
                onWheel={(event) => event.currentTarget.blur()}
              />
              {aadhaarFetching &&
                data?.identification_details?.adhar_number && <RollingLoader />}
            </div>
            {data?.identification_details?.adhar_number &&
            isAadhaarNo === 1 &&
            aadhaarMessage?.includes("Aadhaar number already exists") ? (
              <small className="text-danger">
                Aadhaar number is already in use!
              </small>
            ) : (
              ""
            )}
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-md-3">
            <label htmlFor="uanNo">UAN No.- PF</label>
            <div className="d-flex flex-row position-relative">
              <input
                type="text"
                className={`form-control ${
                  uanMessage?.includes("UAN number already exists")
                    ? "error-border"
                    : null
                }`}
                name="uan_number"
                onChange={handleBankWorkForm}
                value={data?.identification_details?.uan_number}
              />
              {uanFetching && data?.identification_details?.uan_number && (
                <RollingLoader />
              )}
            </div>

            {data?.identification_details?.uan_number &&
            isUanNo === 1 &&
            uanMessage?.includes("UAN number already exists") ? (
              <small className="text-danger">
                UAN number is already in use!
              </small>
            ) : (
              ""
            )}
          </div>

          {/* comment for future use  */}
          {/* <div className="col-md-3">
            <label htmlFor="entityName">Entity Name</label>
            <div className="d-flex flex-row position-relative">
              <input
                type="text"
                className={`form-control`}
                name="entity_name"
                onChange={handleBankWorkForm}
                value={data?.identification_details?.entity_name}
              />
            </div>
          </div> */}
        </div>
        <BankAccoundDetails
          data={data?.bank_account_details}
          handleBankAccountWorkForm={handleBankAccountWorkForm}
          setProfileForm={setProfileForm}
          getBankDetails={getBankDetails}
          bankAccountDetails={bankAccountDetails}
          resetBankDetailsData={resetBankDetailsData}
          userProfileAllData={userProfileAllData}
          isEdit={isEdit}
          servicesError={servicesError}
        />
      </div>
      {servicesFetching && <Loader />}
    </>
  );
};

export default BankIdDetails;
